<template>
  <div class="flex flex-v">
    <!-- 每日报警列表 -->
    <div class="father-module warn-module flex flex-v">
      <div class="title-module flex flex-align-center flex-pack-justify">
        <img
          src="@/assets/image/layout/mod-title.png"
          alt=""
          class="title-module-img"
        />
        <div>每日报警列表</div>
        <span class="num">总计：{{ baojingNum }}</span>
        <a
          href="javascript:;"
          class="more"
          style="margin-top: 0"
          @click="baoxiangqing"
          >查看更多</a
        >
      </div>
      <div class="flex-1 warn-module-main">
        <scroll-top
          :data="tableData"
          :class-option="optionSingleHeight"
          class="seamless-warp"
        >
          <ul class="item">
            <li
              v-for="(item, index) in tableData"
              :key="index"
              @click="itemClick(item)"
              class="items"
            >
              <div class="flex flex-align-center flex-pack-justify">
                <div class="name">{{ item.equipmentTypeName }}</div>
                <div class="time">{{ item.createTime }}</div>
              </div>
              <div class="line"></div>
              <div class="flex flex-align-center flex-pack-justify">
                <div>{{ item.equipmentName }}</div>
                <div class="num">
                  <i
                    class="el-icon-top"
                    style="color: #ff3800"
                    v-if="item.dataValue > item.endWarningValue"
                  ></i>
                  <i
                    v-else-if="item.dataValue < item.beginWarningValue"
                    class="el-icon-bottom"
                    style="color: #e62121"
                  ></i>
                  {{ item.dataValue }}
                </div>
              </div>
            </li>
          </ul>
        </scroll-top>
      </div>
    </div>
    <!--设备案卷统计-->
    <div class="father-module flex-1">
      <div class="title-module flex flex-align-center flex-pack-justify">
        <img
          src="@/assets/image/layout/mod-title.png"
          alt=""
          class="title-module-img"
        />
        <div>设备告警统计</div>
      </div>
      <div class="chartbox">
        <barCharts :chartData="unhandleStatics"></barCharts>
      </div>
    </div>
    <!--案卷闭合统计-->
    <div class="father-module flex-1">
      <div class="title-module flex flex-align-center flex-pack-justify">
        <img
          src="@/assets/image/layout/mod-title.png"
          alt=""
          class="title-module-img"
        />
        <div>告警处理统计</div>
      </div>
      <div class="chartbox">
        <lineCharts :chartData="handleStatics"></lineCharts>
      </div>
    </div>
    <div
      style="
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      "
    >
      <slot name="leftImg"></slot>
    </div>
  </div>
</template>

<script>
import scrollTop from '../scroll.vue'
import barCharts from '../barCharts.vue'
import lineCharts from '../lineCharts.vue'
import moment from 'moment'
export default {
  name: 'rightBox',
  components: {
    scrollTop,
    barCharts,
    lineCharts
  },
  computed: {
    // 滚动动画
    optionSingleHeight() {
      return {
        step: 0.3,
        direction: 1,
        limitMoveNum: 5,
        openWatch: true
      }
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      anjuanNum: 0,
      baojingNum: 0,
      timmerScrol: null,
      unhandleStatics: [],
      handleStatics: []
    }
  },

  mounted() {
    this.timechange()
    this.getbaojing()
    clearInterval(this.timmerScrol)
    this.timmerScrol = null
    this.gaojingtongji(1).then((res) => {
      this.unhandleStatics = res
    })
    this.gaojingtongji(2).then((res) => {
      this.handleStatics = res
    })
    this.timmerScrol = setInterval(() => {
      this.getbaojing()
    }, 60000)
  },

  methods: {
    //获取报警列表
    async getbaojing() {
      console.log('哈')
      let daySart = moment().format('YYYY-MM-DD') + ' 00:00:00'
      let dayEnd = moment().format('YYYY-MM-DD') + ' 23:59:59'
      let data = {
        pageNum: 1,
        pageSize: 9999,
        beginTime: daySart,
        endTime: dayEnd,
        state: 0
      }
      // console.log(data);
      const res = await this.$api.sendPost(
        '/earlyWarning/getAllEarlyWarningAlarm',
        data
      )
      // console.log('报警列表', res);
      this.baojingNum = res.data.total
      this.tableData = res.data.list
    },
    //获取告警统计
    async gaojingtongji(type) {
      //type 1 未处理 type2 已处理
      let daySart = moment().add(-6, 'd').format('YYYY-MM-DD') + ' 00:00:00'
      let dayEnd = moment().format('YYYY-MM-DD') + ' 23:59:59'
      let data = {
        bridgeUuidList: [],
        startTime: daySart,
        endTime: dayEnd
      }
      let res = await this.$api.sendPost(
        `/dashboard/queryWarnCount/${type}`,
        data
      )
      console.log(
        '%c [ res ]-133',
        'font-size:13px; background:pink; color:#bf2c9f;',
        res.data
      )
      return res.data
    },
    //时间
    timechange() {
      Date.prototype.Format = function (fmt) {
        var o = {
          'M+': this.getMonth() + 1, //月份
          'd+': this.getDate(), //日
          'H+': this.getHours(), //小时
          'm+': this.getMinutes(), //分
          's+': this.getSeconds(), //秒
          'q+': Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        }
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        for (var k in o)
          if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
        return fmt
      }
    },
    //跳转案卷
    xiangqing() {
      this.$router.push(`/home/anjuanxinxi`)
    },
    baoxiangqing() {
      this.$router.push(`/home/yujingbaojingqingkuang`)
    }
  },
  destroyed() {
    clearInterval(this.timmerScrol)
    this.timmerScrol = null
  }
}
</script>

<style lang="scss" scoped>
.father-module + .father-module {
  margin-top: 20px;
}

.warn-module {
  height: 300px;

  .warn-module-main {
    min-height: 0;
    margin-bottom: 20px;
    overflow: auto;

    .item {
      .items {
        font-size: 14px;
        color: #f4faff;
        background: linear-gradient(
          134deg,
          rgba(43, 109, 255, 0.3) 0%,
          rgba(77, 221, 255, 0.2) 100%
        );
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 6px;

        .time {
          font-size: 12px;
        }

        .name {
          font-weight: 800;
        }

        .num {
          font-weight: 800;
          color: #0de4de;

          &.orange {
            color: #fdaa00;
          }

          &.red {
            color: #ff3636;
          }
        }

        .line {
          height: 1px;
          margin: 6px 0;
          background: linear-gradient(
            90deg,
            #0ec4dd 0%,
            rgba(7, 114, 111, 0) 100%
          );
        }
      }
    }
  }
}
</style>
